export const standartError = "Something go wrong. Please try later."
export const informationRequestError = "An error occurred while retrieving information";
export const sellersRequestErrorMessage = "sellersRequestErrorMessage";

export const iframeNotSupportedError = "Your browser does not support iframe, please upgrade your browser to continue using the site";